export enum EOperationalHelpSurface {
  RestaurantOwner = 0,
  Reseller = 1,
  Courier = 2,
}
